import { Box, Typography } from '@mui/material';
import { Trans } from '@lingui/macro';
import React from 'react';
import { IPositionToken } from '../../../types/uniswapTokens';
import { TokenIcon } from '../../../components/primitives/TokenIcon';
import { displayTokenAmount } from '../../../utils/displayTokenAmount';

export interface ITxPositionDetailsProps {
  token0: IPositionToken;
  token1: IPositionToken;
}

export const TxPositionDetails = ({ token0, token1 }: ITxPositionDetailsProps) => (
  <Box sx={{ pt: 5 }}>
    <Typography sx={{ mb: 1 }} color="text.secondary">
      <Trans>Position Liquidity</Trans>
    </Typography>

    <Box
      sx={(theme) => ({
        display: 'flex',
        justifyContent: 'space-between',
        p: 3,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '8px 8px 0 0',
        '.MuiBox-root:last-of-type': {
          mb: 0,
        },
      })}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TokenIcon symbol={token0.iconSymbol} fontSize="large" />
        <Box sx={{ pl: 2, overflow: 'hidden' }}>
          <Typography variant="h4" noWrap>
            {token0.name}
          </Typography>

          <Box sx={{ p: { xs: '0', xsm: '2px 0px' } }}>
            <Typography variant="subheader2" color="text.muted" noWrap>
              {token0.symbol}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ textAlign: 'right' }}>
        <Typography variant="h4" noWrap>
          {displayTokenAmount(token0.liquidity)}
        </Typography>
        <Typography variant="subheader2" color="text.muted" noWrap>
          ${token0.marketReferenceCurrencyValue.toFixed(2)}
        </Typography>
      </Box>
    </Box>
    <Box
      sx={(theme) => ({
        display: 'flex',
        justifyContent: 'space-between',
        p: 3,
        border: `1px solid ${theme.palette.divider}`,
        borderTop: 'unset',
        borderRadius: '0 0 8px 8px',
        '.MuiBox-root:last-of-type': {
          mb: 0,
        },
      })}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TokenIcon symbol={token1.iconSymbol} fontSize="large" />
        <Box sx={{ pl: 2, overflow: 'hidden' }}>
          <Typography variant="h4" noWrap>
            {token1.name}
          </Typography>

          <Box
            sx={{
              p: { xs: '0', xsm: '2px 0px' },
            }}
          >
            <Typography variant="subheader2" color="text.muted" noWrap>
              {token1.symbol}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ textAlign: 'right' }}>
        <Typography variant="h4" noWrap>
          {displayTokenAmount(token1.liquidity)}
        </Typography>
        <Typography variant="subheader2" color="text.muted" noWrap>
          ${token1.marketReferenceCurrencyValue.toFixed(2)}
        </Typography>
      </Box>
    </Box>
  </Box>
)
